import { getScreenName } from '../../../Utils/helper';

import { fireEvent } from '../../../Utils/fireEvent';

export const guestPopupEvents = (category, screen) => {
  fireEvent({
    category: category,
    screen_name: getScreenName(),
    parent: `stay_on_${screen}`,
  });
};
export const clickedCtaEvent = (cta, screen) => {
  fireEvent({
    category: 'clicked_cta',
    screen_name: getScreenName(),
    parent: `stay_on_${screen}`,
    cta: cta,
  });
};
export const discardGuestPopup = () => {
  fireEvent({
    category: 'discard_popup',
    screen_name: getScreenName(),
    parent: `stay_on_${screen}`,
    section_name: '',
  });
};
